import { Component, Inject, VERSION } from "@angular/core";
import { StoreSelectorsService } from "../../services";
import { Compbaser } from "../compbaser";
import { TranslocoService } from "@ngneat/transloco";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NewNodeDialog } from "../category-tree/add-node/add-node.component";
const {version: appVersion} = require('../../../../package.json');

@Component({
    selector: "app-dialog-release-notes",
    templateUrl: "./dialog-release-notes.component.html",
    styleUrls: ["./dialog-release-notes.component.scss"],
})
export class DialogReleaseNotesComponent extends Compbaser {
    version = VERSION.full;
    appVersion = appVersion;
    releaseNotes: Array<{ date: string; text: string; description: string; timestamp: number }> = [];
    showSpinner = true;

    readMe = {
        "35": {
            text: "live AI driven Charts",
            description: "create any AI driven data feed and load it directly into your live charts",
            date: "11-02-2025"
        },
        "34": {
            text: "live AI driven JSON Player",
            description: "create any AI driven data feed and load it directly into your JSON Player for unique templates",
            date: "11-01-2025"
        },
        "33": {
            text: "enhanced layering of items in scene",
            description: "improved the UI and UX of layers in scenes with cleaner design and functionality",
            date: "10-29-2025"
        },
        "32": {
            text: "JSON Player now support AI generation",
            description: "you can now load literally any data or news or feed you like into the JSON player",
            date: "10-25-2025"
        },
        "31": {
            text: "Image/Video content generator",
            description: "new stock library of millions of videos and images to build the perfect content",
            date: "10-25-2025"
        },
        "30": {
            text: "AnyFeed RSS scroll component with AI",
            description: "use the power of AI to create any feed, of any topic, that you interested for smooth scrolling RSS",
            date: "10-23-2025"
        },
        "29": {
            text: "data visualization, with 36 new component",
            description: "added 36 new rich graphs, charts, pies and much more for rich data visualization",
            date: "10-22-2025"
        },
        "28": {
            text: "font selector improvements",
            description: "added enhanced font selection with custom font and preview pane",
            date: "10-20-2025"
        },
        "27": {
            text: "scheduler forecast",
            description: "compressive proof of future play report for content schilling of scenes and resources",
            date: "10-20-2025"
        },
        "26": {
            text: "effect pre-sets add-ons",
            description: "added over 100+ new presets for blur, shadow, border, glow and more",
            date: "10-18-2025"
        },
        "25": {
            text: "pallets chooser",
            description: "easily create colors themes for label, components and more",
            date: "10-18-2025"
        },
        "24": {
            text: "Advanced user settings",
            description: "provide additional detail for better user management in global settings",
            date: "10-17-2025"
        },
        "23": {
            text: "SignPlayer now supports the new Slides",
            description: "The latest version of SignPlayer fully supports touch-enabled Slides.",
            date: "10-16-2025"
        },
        "22": {
            text: "Enhanced Product Page UI",
            description: "Improved the product page experience with a cleaner design and additional product options.",
            date: "10-16-2025"
        },
        "2": {
            text: "Major Update: Touch & Slide Editor",
            description: "Added navigation support with a new icon library and advanced touch controls.",
            date: "10-15-2025"
        },
        "3": {
            text: "Scene Editor Toolbar Improvements",
            description: "Optimized for mobile with enhanced UI/UX and automatic scaling.",
            date: "10-14-2025"
        },
        "4": {
            text: "AI Resource Manager",
            description: "Create AI resources in the background and receive notifications when they're ready.",
            date: "10-13-2025"
        },
        "5": {
            text: "AI Video Creator (Runway Integration)",
            description: "Now powered by the latest OpenAI and Gemini AI for seamless image and video creation.",
            date: "10-12-2025"
        },
        "6": {
            text: "AI Image Creator Enhancements",
            description: "Simplified the UI for background and resource creation with major performance improvements.",
            date: "10-11-2025"
        },
        "7": {
            text: "Touch Animation Enhancements",
            description: "Added duration, scale, and opacity options to touch-based animations.",
            date: "10-11-2025"
        },
        "8": {
            text: "Collection Enhancements",
            description: "Introduced idle timeout that automatically returns to the selected scene or slide.",
            date: "10-09-2025"
        },
        "9": {
            text: "New Icon Library (2,000+ Icons)",
            description: "Apply vibrant, scalable icons of any size and color to any component.",
            date: "10-09-2025"
        },
        "10": {
            text: "Slides with Playlist and Collection Support",
            description: "Slides now support autoplay or user-triggered playback modes.",
            date: "10-06-2025"
        },
        "11": {
            text: "Effect Presets",
            description: "Choose from prebuilt effect presets for faster and easier visual setup.",
            date: "10-03-2025"
        },
        "12": {
            text: "Slide Hotkeys",
            description: "Navigate slides quickly using customizable keyboard shortcuts.",
            date: "10-02-2025"
        },
        "13": {
            text: "Deep Night Theme",
            description: "Choose between Dark, Light, or the new Deep Night theme featuring striking color contrasts.",
            date: "10-01-2025"
        },
        "14": {
            text: "New Animation Engine",
            description: "Introducing a GPU-powered Digital Signage animation engine for ultra-smooth performance.",
            date: "09-22-2025"
        },
        "15": {
            text: "Slides / Presentations",
            description: "Build PowerPoint-style touch presentations or interactive kiosks powered by Slides.",
            date: "09-20-2025"
        },
        "16": {
            text: "Music Player Component",
            description: "Add background music to your digital displays with the new music player component.",
            date: "09-18-2025"
        },
        "17": {
            text: "Label Enhancements",
            description: "Added auto-select, multi-label editing, and more — making labels more dynamic and fun to use.",
            date: "09-01-2025"
        },
        "18": {
            text: "Improved Local Cache (SignPlayer)",
            description: "Enhanced mapping and caching logic for faster offline performance.",
            date: "08-12-2025"
        },
        "19": {
            text: "Simplified & Advanced UI Modes",
            description: "Users can now switch between a simplified or advanced SignStudio layout for an easier workflow.",
            date: "08-10-2025"
        },
        "20": {
            text: "100+ New Video Tutorials",
            description: "Added over 100 new tutorials and improved the Watchdog for Windows and Android.",
            date: "08-07-2025"
        },
        "21": {
            text: "New Watchdog System",
            description: "Fully refactored and enhanced Watchdog for Windows and Android with improved reliability.",
            date: "08-03-2025"
        }
    };


    constructor(
        public dialogRef: MatDialogRef<NewNodeDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private storeSelectorsService: StoreSelectorsService,
        private translocoService: TranslocoService,
        private _http: HttpClient, private router: Router) {
        super();
        this.version = data;
        this.transformReadMe();
        this.startSpinnerTimer();
    }

    private startSpinnerTimer() {
        setTimeout(() => {
            this.showSpinner = false;
        }, 2000);
    }

    private transformReadMe() {
        this.releaseNotes = Object.keys(this.readMe).map(key => {
            const dateStr = this.readMe[key].date;
            // Convert date string "MM-DD-YYYY" to Unix timestamp
            const [month, day, year] = dateStr.split('-').map(Number);
            const timestamp = new Date(year, month - 1, day).getTime();

            return {
                date: dateStr,
                text: this.readMe[key].text,
                description: this.readMe[key].description,
                timestamp
            };
        })
        // Sort by timestamp descending (newest first)
        .sort((a, b) => b.timestamp - a.timestamp);
    }

    reload() {
        this.dialogRef.close(true);
    }
}

